<template>
    <div>
        <EditorBlock title="Editor" :block="block">
            <template #cardbody>
                <div class="pt-2">
                    <tip-tap-editor v-model="block.value"></tip-tap-editor>
                </div>
            </template>
        </EditorBlock>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
</style>

<script>
import TipTapEditor from "@/components/tiptap/TipTapEditor";
import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";
export default {
    data: () => ({
        editor: null
    }),
    props: ['block'],
    components: {
        EditorBlock,
        TipTapEditor

    },
    methods: {

    },
    mounted () {

    }
}
</script>
